class OngoingFilter {
  filter(events: VideoStreamEvent[], hideOnGoingEvents: boolean = false): VideoStreamEvent[] {
    if (hideOnGoingEvents === false) return events;

    return events.filter(el => el.ongoing !== true);
  }
}

export default OngoingFilter;
